module.exports = __webpack_public_path__ + "static/media/automation-initplay-icon.cbe28bf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation-initplay-icon.svg
// module id = ./src/assets/images/automation-initplay-icon.svg
// module chunks = 0